<template>
	<div style="margin-left:50px">
	  <div class="subTop1">
	    <em>Frontier Technology</em>
	    <span>技术前沿</span>
	    <router-link to="/jishu" class="more" @click.native="$track([['pagetype','首页-技术前沿-更多-点击']])">更多</router-link>
	  </div>
	  <a @click="jishuList.data[0].id?jumppush('/detail/'+jishuList.data[0].id):''" class="top">
	    <img :src="jishuList.data?jishuList.images[jishuList.data[0].id]:''"/>
	    <p>{{jishuList.data?jishuList.data[0].title:''}}</p>
	  </a>
	  <ul class="newsWap">
			<li v-for="(item,index) in jishuList.data" v-if="index>0&&index<5">
				<a @click="jumppush('/detail/'+item.id)" :title="item.title">{{item.title}}</a>
			</li>
	    <!-- <li><a href="##">又见无理打压！美国向中俄出口高端GPU芯片需许可</a></li>
	    <li><a href="##">200余家企业参展WAIC大会上海AI+元宇宙全新起</a></li>
	    <li><a href="##">人工智能算法“着凉”月球永久阴影区</a></li>
	    <li><a href="##">2022互联网岳麓峰会开幕聚焦先进计算、元宇宙</a></li> -->
	  </ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				jishuList: [],
			}
		},
		created:function(){
			this.jishufnc();
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			jishufnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'szjj/searchArticles',
						responseType: 'json',
						params: {
							columnID: '253485e740064be4a8dcee24b4330119',
							// isTopArticle: '1',
							iPage:'1',
							pageSize:'5',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.jishuList = response.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		}
	}
</script>

<style>
</style>
